(function () {
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function getSoftwareYears(brand) {
    var table = {
      apple: 6,
      samsung: 5,
      google: 5,
      oneplus: 4,
      xiaomi: 3,
      oppo: 3,
      sony: 3,
      motorola: 3,
      nokia: 3,
      other: 3
    };
    return table[brand] || 3;
  }

  function getPerformanceBaseYears(tier) {
    var table = { flagship: 5, mid: 4, budget: 3 };
    return table[tier] || 4;
  }

  function getCyclesPerYear(chargingStyle) {
    var table = { once: 300, more: 450, topups: 550 };
    return table[chargingStyle] || 350;
  }

  function usageCycleMultiplier(usage) {
    if (usage === "light") return 0.90;
    if (usage === "heavy") return 1.10;
    return 1.00;
  }

  function fastChargeWearMultiplier(fastCharge) {
    if (fastCharge === "often") return 1.15;
    if (fastCharge === "sometimes") return 1.07;
    return 1.00;
  }

  function usagePerformanceAdjustment(usage) {
    if (usage === "light") return 0.5;
    if (usage === "heavy") return -0.5;
    return 0;
  }

  // Calculator: hardware lifespan is NOT limited by software support.
  window.calculatePhoneLifespanFGU = function (inputs) {
    var currentYear = inputs.currentYear || new Date().getFullYear();

    // Software support info (reported separately)
    var softwareYears = getSoftwareYears(inputs.brand);
    var softwareEndYear = inputs.modelYear + softwareYears;
    var softwareRemainingYears = clamp(softwareEndYear - currentYear, 0, 50);

    // Battery
    var baseCycles = getCyclesPerYear(inputs.chargingStyle);
    var adjustedCyclesPerYear =
      baseCycles *
      usageCycleMultiplier(inputs.usage) *
      fastChargeWearMultiplier(inputs.fastCharge);

    var batteryComfortYears = 500 / adjustedCyclesPerYear;
    var batteryMaxYears = 800 / adjustedCyclesPerYear;

    if (inputs.batteryReplace) {
      batteryComfortYears += 2.0;
      batteryMaxYears += 2.0;
    }

    // Performance
    var performanceYears =
      getPerformanceBaseYears(inputs.tier) + usagePerformanceAdjustment(inputs.usage);

    // Hardware results
    var comfortableHardware = Math.min(batteryComfortYears, performanceYears);
    var maxUsableHardware = Math.min(batteryMaxYears, performanceYears + 1);

    // Clamp outputs to keep things sane
    comfortableHardware = clamp(comfortableHardware, 0, 10);
    maxUsableHardware = clamp(maxUsableHardware, 0, 12);

    return {
      comfortableYears: comfortableHardware,
      maxUsableYears: maxUsableHardware,
      softwareEndYear: softwareEndYear,
      softwareRemainingYears: softwareRemainingYears,
      securitySupported: softwareRemainingYears > 0
    };
  };

  function renderResult(result, resultsEl) {
    var supportLine = result.securitySupported
      ? "<p><strong>Security support:</strong> likely until " + result.softwareEndYear + " (" + result.softwareRemainingYears.toFixed(1) + " years remaining)</p>"
      : "<p><strong>Security support:</strong> ended in " + result.softwareEndYear + "</p>";

    var warning = result.securitySupported
      ? ""
      : "<p class='fgu-calc-note'><strong>Note:</strong> If your phone no longer gets security updates, it may still work fine, but it’s not recommended for banking, sensitive logins, or storing anything you’d cry about losing.</p>";

    resultsEl.innerHTML =
      "<p><strong>Comfortable lifespan (hardware):</strong> about " + result.comfortableYears.toFixed(1) + " years</p>" +
      "<p><strong>Max usable lifespan (hardware):</strong> about " + result.maxUsableYears.toFixed(1) + " years</p>" +
      supportLine +
      warning;
  }

  function initCalc(root) {
    var btn = root.querySelector("[data-fgu-calc-btn]");
    var results = root.querySelector("[data-fgu-results]");
    if (!btn || !results) return;

    results.innerHTML = "<p>Enter your phone details, then hit Calculate.</p>";

    btn.addEventListener("click", function () {
      var modelYearEl = root.querySelector("[data-fgu-model-year]");
      var modelYear = parseInt(modelYearEl && modelYearEl.value, 10);

      if (!modelYear || isNaN(modelYear) || modelYear < 2007 || modelYear > 2035) {
        results.innerHTML = "<p><strong>Please enter a valid model year</strong> (e.g. 2021).</p>";
        return;
      }

      var result = window.calculatePhoneLifespanFGU({
        brand: root.querySelector("[data-fgu-brand]").value,
        modelYear: modelYear,
        usage: root.querySelector("[data-fgu-usage]").value,
        chargingStyle: root.querySelector("[data-fgu-charging]").value,
        fastCharge: root.querySelector("[data-fgu-fastcharge]").value,
        batteryReplace: root.querySelector("[data-fgu-batteryreplace]").checked,
        tier: root.querySelector("[data-fgu-tier]").value
      });

      renderResult(result, results);
    });
  }

  function boot() {
    document.querySelectorAll("[data-fgu-phone-calc]").forEach(initCalc);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();